import React from 'react';
import { FieldComponentProps } from 'components/anvilFormFillable/fields/types';
import InputText from 'components/common/InputText';
import { placeholderByType } from 'components/anvilFormFillable/utils';

export default function ShortText({
  field,
  value,
  onChange,
  ...props
}: FieldComponentProps) {
  const placeholder = placeholderByType[field.type] ?? 'Please enter a value';
  return (
    <InputText
      {...props}
      id={field?.id ?? ''}
      key={field?.id}
      autoFocus
      placeholder={placeholder}
      value={(value?.value ?? '') as string}
      maxLength={64}
      onChange={(e) => {
        onChange?.({ ...value, value: e.target.value });
      }}
      className="w-full"
    />
  );
}
